const initRotatorHero = () => {
	document.querySelectorAll( '.rotator-hero .v4-rotator' ).forEach( ( rotator ) => {
		const slides = rotator.querySelectorAll( '.v4-slide' )

		if ( slides.length < 2 ) {
			return
		}

		let current = 0

		setInterval( () => {
			slides[ current ].classList.remove( 'on' )
			current = ( current + 1 ) % slides.length
			slides[ current ].classList.add( 'on' )
		}, 2800 )
	} )
}

export { initRotatorHero }
